(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('queues', {
                parent: 'management',
                url: '/queues?search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.Queue.home.title'
                },
                params: {
                    repeatable: {
                        value: '-1'
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    status: 'all',
                    objectId: '-1',
                    start: null,
                    stop: null,
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    systemNowPage: {
                        value: '1',
                        squash: true
                    },
                    systemOncePage: {
                        value: '1',
                        squash: true
                    },
                    systemScheduledPage: {
                        value: '1',
                        squash: true
                    },
                    systemCompletedPage: {
                        value: '1',
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/queue/queues.html',
                        controller: 'QueueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            systemNowPage: PaginationUtil.parsePage($stateParams.systemNowPage),
                            systemOncePage: PaginationUtil.parsePage($stateParams.systemOncePage),
                            systemScheduledPage: PaginationUtil.parsePage($stateParams.systemScheduledPage),
                            systemCompletedPage: PaginationUtil.parsePage($stateParams.systemCompletedPage),
                            repeatable: $stateParams.repeatable,
                            search: $stateParams.search,
                            status: $stateParams.status,
                            objectId: $stateParams.objectId,
                            start: $stateParams.start,
                            stop: $stateParams.stop
                        }
                    }]
                }
            })
            .state('queues-detail', {
                parent: 'queues',
                url: '/queues/{id}/queue-detail',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/queue/queues-detail.html',
                        controller: 'QueueDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('Queue');
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Queue', function ($stateParams, Queue) {
                        return Queue.get({id: $stateParams.id});
                    }]
                }
            })
            .state('queues.delete', {
                parent: 'queues',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/queue/queues-delete-dialog.html',
                        controller: 'QueuesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Queue', function (Queue) {
                                return Queue.get({id: $stateParams.id});
                            }],
                        }
                    }).result.then(function () {
                        $state.go('queues', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });


    }

})();
